import { useApiMutation } from "@babackapp/private-api-client/client/use-api-mutation";
import { useQueryClient } from "@tanstack/react-query";

export type ShopPortalPatch = {
  enabled?: boolean;
  legacyPortalReason?: string;
};

/**
 * Patches a shop's V3 customer portal opt-in (`admin.returnWidget.enabled`) and
 * the reason it was moved back to the legacy widget, from the super admin shops
 * list. The list serves both live from the shop document, so invalidating it is
 * enough to reflect the new values.
 */
export function useUpdateShopPortal(shopId: string) {
  const queryClient = useQueryClient();

  return useApiMutation("patch", "/shops/{shopId}/admin", {
    invalidate: () =>
      queryClient.invalidateQueries({
        queryKey: ["get", "/super-admin/shops"],
      }),
    mapVariables: (returnWidget: ShopPortalPatch) => ({
      params: { path: { shopId } },
      body: { returnWidget },
    }),
  });
}
